export const TEXT_CONSTANTS = {
    ERROR_MESSAGES: {
        INVALID_PHONEORMETERNUM_MESSAGE: "Enter a valid 10-digit phone number or meter number exactly as shown on your bill or account, e.g. 2223334444, I123456 or S123456",
        INVALID_PHONEORMETERNUM_MESSAGETX: "Enter a valid 10-digit phone number or meter number (e.g. I123456) exactly as shown on your bill or account.",
        INVALID_PHONEORMETERNUM_MESSAGEIN: "Enter a valid 10-digit phone number or meter number (e.g. S123456) exactly as shown on your bill or account.",
        REQUIRE_HOUSENUM_MESSAGE: "Street Number is required",
        SELECT_PAS_PREF_MESSAGE: "Select at least one alert preference",
        INVALID_EMAIL: "Enter a valid Email",
        INVALID_PHONE: "Enter a valid Phone Number"
    }
}